import { useProfile } from 'app/components/profile/useProfile'
import { ProfileShadcnComponent } from 'app/components/profile/ProfileShadcnComponent'

export const handle = {
  title: `Profile`,
  breadcrumb: `Profile`,
}

export default function Profile() {
  const props = useProfile()
  if (!props.user) return null
  return <ProfileShadcnComponent {...props} user={props.user} />
}
